<template>
    <div i="root" v-cloak @touchmove.prevent>
        <!-- <div id="header">
                <div class="status" id=""></div>
            </div> -->
        <div id="root_header" class="pt0"></div>
        <div class="root-bottom line-t" id="footer">
            <div class="menues clearfix">
                <div class="menue" @click="toUrl('/')" :class="{'active':footer.ac0}">
                    <i class="iconfont bg1"></i>
                    <div class="menue-txt">首页</div>
                </div>
                <div class="menue" @click="toUrl('/root_classify')" :class="{'active':footer.ac1}">
                    <i class="iconfont bg2"></i>
                    <div class="menue-txt">分类</div>
                </div>
                <div class="menue" @click="islogin('/root_cart')" :class="{'active':footer.ac2}">
                    <i class="iconfont bg3"></i>
                    <div class="menue-txt">购物车</div>
                </div>
                <div class="menue" @click="toUrl('/root_personal')" :class="{'active':footer.ac3}">
                    <i class="iconfont bg4"></i>
                    <div class="menue-txt">我的</div>
                </div>
            </div>
        </div>

    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    @import '~sass/common/tool';
    @import '~sass/common/base';
    @import '~sass/root';
</style>
<script>

    export default {
        data() {
            return {
                footer: {}
            }
        },
        methods: {
            /* 跳转 */
            toUrl: function (url, val) {
                tools.router.replace({ path: url, query: val });
            },
            // //底部导航切换
            change: function (pageNun) {
                var _this = this;
                var copyFooterImg = {};
                copyFooterImg['ac' + pageNun] = true;
                _this.footer = copyFooterImg;
            },
        },
        watch: {

        },
        components: {

        },
        filters: {

        },
        mounted() {
            var that = this;
            that.$on('changeNav', function (type) {
                var copyFooterImg = {};
                copyFooterImg['ac' + type] = true;
                _this.footer = copyFooterImg;
            })
        }
    }
</script>


// WEBPACK FOOTER //
// Root.vue?5778f5ba